module.exports = __webpack_public_path__ + "img/icon_house.b4ddee7f.svg";